import { CarModel } from '@support/json';

export default defineNuxtRouteMiddleware(to => {
  const modelCode = to.query.productModelCode;

  // 更新路由元数据
  to.meta.isShowChatIcon = modelCode !== CarModel.G30;
});

// 页面配置
definePageMeta({
  middleware: ['recall-success']
});
